import { useContext } from 'react';

import { AddonsContext, AddonsContextType } from '../context/AddonsContext';

export const useAddons = (): AddonsContextType => {
  const context = useContext(AddonsContext);

  if (!context) {
    throw new Error('useAddons must be used within AddonsProvider');
  }

  return context;
};
